/* ==========================================================================
   JV LESSON — shared behaviour for the standalone course sections.
   Loaded once (guarded). Works entirely by scanning the page + event
   delegation, so it does not matter how the merchant orders the sections.
     • builds the jump menu from [data-jv-nav] part/module anchors
     • progress bar (document scroll) + active-link highlight
     • printer-view toggle (body.jv-printview) + print button
     • clickable quizzes (multiple-choice + find-the-image)
   ========================================================================== */
(function(){
  if (window.__jvLessonInit) return;
  window.__jvLessonInit = true;

  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }

  ready(function(){
    var body = document.body;

    /* ---- jump menu (built from part/module anchors in DOM order) ---- */
    var ol = document.querySelector('.jv-shell__jump ol');
    if (ol){
      var navs = document.querySelectorAll('[data-jv-nav]');
      var html = '';
      navs.forEach(function(el){
        var title = el.getAttribute('data-jv-title') || '';
        if (el.getAttribute('data-jv-nav') === 'part'){
          html += '<li class="is-part">' + title + '</li>';
        } else {
          html += '<li><a href="#' + el.id + '" data-jv-jumplink>' + title + '</a></li>';
        }
      });
      ol.innerHTML = html;
    }

    /* ---- jump toggle + smooth scroll ---- */
    var jumpBtn = document.querySelector('[data-jv-jumptoggle]');
    var jump = document.querySelector('.jv-shell__jump');
    if (jumpBtn && jump){
      jumpBtn.addEventListener('click', function(){
        var open = jump.classList.toggle('is-open');
        jumpBtn.setAttribute('aria-expanded', open);
      });
    }
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('[data-jv-jumplink]');
      if (!a) return;
      e.preventDefault();
      var t = document.querySelector(a.getAttribute('href'));
      if (t){ window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 80, behavior:'smooth' }); }
      if (jump){ jump.classList.remove('is-open'); }
    });

    /* ---- progress bar + active link ---- */
    var fill = document.querySelector('.jv-shell__fill');
    var pct = document.querySelector('.jv-shell__pct');
    function onScroll(){
      var h = document.documentElement;
      var total = h.scrollHeight - h.clientHeight;
      var p = total > 0 ? Math.round((h.scrollTop || body.scrollTop) / total * 100) : 0;
      if (fill) fill.style.width = p + '%';
      if (pct) pct.textContent = p + '%';
      var links = document.querySelectorAll('[data-jv-jumplink]');
      var activeIdx = -1;
      links.forEach(function(a, i){
        var t = document.querySelector(a.getAttribute('href'));
        if (t && t.getBoundingClientRect().top < 120) activeIdx = i;
      });
      links.forEach(function(a, i){ a.classList.toggle('is-active', i === activeIdx); });
    }
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll);
    onScroll();

    /* ---- printer view toggle + print ---- */
    document.addEventListener('click', function(e){
      var pv = e.target.closest && e.target.closest('[data-jv-printview]');
      if (pv){
        var on = body.classList.toggle('jv-printview');
        pv.textContent = on ? 'Back to online view' : 'Preview printer view';
        window.scrollTo({ top:0, behavior:'smooth' });
        return;
      }
      var pr = e.target.closest && e.target.closest('[data-jv-print]');
      if (pr){ window.print(); }
    });

    /* ---- quizzes (delegated) ---- */
    document.addEventListener('click', function(e){
      var opt = e.target.closest && e.target.closest('.jv-opt, .jv-imgopt');
      if (!opt) return;
      var quiz = opt.closest('[data-jv-quiz]');
      if (!quiz || quiz.getAttribute('data-solved') === '1') return;
      var okFb = quiz.querySelector('[data-jv-ok]');
      var noFb = quiz.querySelector('[data-jv-no]');
      if (opt.getAttribute('data-correct') === 'true'){
        opt.classList.add('is-correct');
        if (okFb) okFb.classList.add('is-show');
        if (noFb) noFb.classList.remove('is-show');
        quiz.setAttribute('data-solved', '1');
      } else {
        opt.classList.add('is-wrong');
        if (noFb) noFb.classList.add('is-show');
        setTimeout(function(){ opt.classList.remove('is-wrong'); }, 900);
      }
    });

    /* ---- prev/next: mark lesson complete (localStorage keyed by page path) ----
       localStorage remains the READ path / source of truth for the UI (see
       jv-lesson-cloudflare.js header). The account-level sync below is a
       best-effort ADDITION, never a replacement -- it cannot fail the click,
       block the checkmark, or contradict what's already shown. */
    function pathOf(url){ try { var a = document.createElement('a'); a.href = url; return a.pathname; } catch(e){ return url; } }
    function isDone(path){ try { return localStorage.getItem('jvc-done:' + path) === '1'; } catch(e){ return false; } }
    function lessonHandleOf(path){
      var clean = String(path || '').replace(/\/+$/, '');
      var parts = clean.split('/');
      return parts[parts.length - 1] || '';
    }
    var thisPath = window.location.pathname;
    document.querySelectorAll('[data-jv-mark]').forEach(function(btn){
      var doneLabel = btn.getAttribute('data-done-label') || 'Lesson complete';
      if (isDone(thisPath)){ btn.classList.add('is-done'); btn.textContent = doneLabel; }
      btn.addEventListener('click', function(){
        var alreadyDone = isDone(thisPath);
        try { localStorage.setItem('jvc-done:' + thisPath, '1'); } catch(e){}
        btn.classList.add('is-done'); btn.textContent = doneLabel;
        // Only sync on the FIRST completion of this lesson in this browser --
        // a re-click on an already-done button is a UI no-op, not a new event,
        // and the server side is idempotent on repeats anyway (progressRepo.ts
        // first-write-wins), so this is a courtesy to avoid a pointless call,
        // not a correctness requirement.
        if (!alreadyDone && window.JVAcademyCloudflare && window.JVAcademyCloudflare.isEnabled()) {
          window.JVAcademyCloudflare.syncLessonComplete(lessonHandleOf(thisPath), new Date().toISOString());
        }
      });
    });

    /* ---- course hub: complete ticks, progress meter, sequential unlock ---- */
    var hub = document.querySelector('[data-jv-hub]');
    if (hub){
      var cards = Array.prototype.slice.call(hub.querySelectorAll('[data-jv-lesson]'));
      var sequential = hub.getAttribute('data-jv-sequential') === '1';
      var doneCount = 0, prevDone = true;
      cards.forEach(function(card, i){
        var key = pathOf(card.getAttribute('data-key') || '');
        var done = isDone(key);
        if (done){ card.classList.add('is-complete'); doneCount++; }
        var manualLock = card.getAttribute('data-locked') === '1';
        var seqLock = sequential && i > 0 && !prevDone;
        if (manualLock || seqLock){ card.classList.add('is-locked'); card.setAttribute('aria-disabled', 'true'); }
        prevDone = done;
      });
      var hubFill = hub.querySelector('[data-jv-hub-fill]');
      var hubTxt = hub.querySelector('[data-jv-hub-text]');
      /* The denominator counts only lessons a student can actually COMPLETE.
         A manually-locked card with no link is a placeholder for unbuilt
         content, not an achievable lesson -- counting it meant a student who
         finished everything read "35 of 36 lessons complete, 97%" as the last
         thing the course said to them.
         Sequential locks are NOT excluded: those unlock as the student
         progresses, so they are genuinely achievable and belong in the total.
         This is correct whichever way the module-36 question is decided -- if
         that lesson is built it gains a link, stops being manually locked,
         and re-enters the count on its own. */
      var countable = cards.filter(function(card){
        var manualLock = card.getAttribute('data-locked') === '1';
        /* Test data-key, NOT href: the card IS the <a>, and its href falls
           back to '#' when the block has no link (course-hub markup), so
           getAttribute('href') is truthy even for an unbuilt lesson.
           data-key is the raw block link and is genuinely empty. */
        var hasLink = !!(card.getAttribute('data-key') || '').trim();
        return !(manualLock && !hasLink);
      });
      var total = countable.length || cards.length;
      var pctVal = total ? Math.round(doneCount / total * 100) : 0;
      if (hubFill) hubFill.style.width = pctVal + '%';
      if (hubTxt) hubTxt.textContent = doneCount + ' of ' + total + ' lessons complete';
    }
  });
})();
